// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"31d6cfe0","239":"77a3a04b","368":"79d81233","630":"e760098c","774":"5d63a571","801":"b5312379"}[chunkId] + ".chunk.css";
};